// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-9cf123ba]{font-size:23px;border-radius:20px}.card[data-v-9cf123ba],.icon[data-v-9cf123ba]{color:#fff}.text-light[data-v-9cf123ba]{margin-top:30px;font-weight:300;font-size:23px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
